var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7778 5.55553C12.7778 4.81882 12.4851 4.11228 11.9642 3.59134C11.4433 3.07041 10.7367 2.77775 10 2.77775C9.26329 2.77775 8.55676 3.07041 8.03582 3.59134C7.51489 4.11228 7.22223 4.81882 7.22223 5.55553C7.22223 6.29224 7.51489 6.99878 8.03582 7.51971C8.55676 8.04065 9.26329 8.33331 10 8.33331C10.7367 8.33331 11.4433 8.04065 11.9642 7.51971C12.4851 6.99878 12.7778 6.29224 12.7778 5.55553ZM5.55556 5.55553C5.55556 4.37679 6.02381 3.24633 6.85731 2.41283C7.6908 1.57934 8.82127 1.11108 10 1.11108C11.1787 1.11108 12.3092 1.57934 13.1427 2.41283C13.9762 3.24633 14.4445 4.37679 14.4445 5.55553C14.4445 6.73427 13.9762 7.86473 13.1427 8.69823C12.3092 9.53172 11.1787 9.99997 10 9.99997C8.82127 9.99997 7.6908 9.53172 6.85731 8.69823C6.02381 7.86473 5.55556 6.73427 5.55556 5.55553ZM3.93403 17.2222H16.066C15.757 15.0243 13.8681 13.3333 11.5868 13.3333H8.4132C6.13195 13.3333 4.24306 15.0243 3.93403 17.2222ZM2.22223 17.8576C2.22223 14.4375 4.99306 11.6666 8.4132 11.6666H11.5868C15.007 11.6666 17.7778 14.4375 17.7778 17.8576C17.7778 18.4271 17.316 18.8889 16.7465 18.8889H3.25348C2.68403 18.8889 2.22223 18.4271 2.22223 17.8576Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.8946f1a59e64866d78e4a14c0c8eb6cd.svg";
export { ForwardRef as ReactComponent };